module.exports = "img/photo3.17dd76.jpg";